import { render, staticRenderFns } from "./MaterDrawerEdit.vue?vue&type=template&id=47b2e758"
import script from "./MaterDrawerEdit.vue?vue&type=script&lang=js"
export * from "./MaterDrawerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports